import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  message: '',
  isDisplay: false,
};

const hintSlice = createSlice({
  name: 'hint',
  initialState,
  reducers: {
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setIsDisplay: (state, action) => {
      state.isDisplay = action.payload;
    },
    reset: () => initialState,
  },
});

export const { setMessage, setIsDisplay, reset } = hintSlice.actions;

export default hintSlice.reducer;
